import { Injectable } from "@angular/core";
import { ValidatorFn, AbstractControl } from "@angular/forms";
import { isAfter, isSameDay, isValid, isBefore, addDays } from 'date-fns';
import { DateService } from './date.service';

@Injectable()
export class ValidatorsService {
  constructor(private dateService: DateService) { }

  public isValidDate(control: AbstractControl): {[key: string]: any} | null {
    if(!control.value) {
        return null;
    }
      
    return isValid(control.value) ? 
      null : 
      { 
        validateDate: { valid: false }
      };
  };


  public mustBeOnOrAfterDate(date: Date): ValidatorFn {
    return this.mustBeAfter(date, true);
  }

  public mustBeAfterDate(date: Date): ValidatorFn {
    return this.mustBeAfter(date, false);
  }

  public mustBeOnOrBeforeDate(date: Date): ValidatorFn {
    return this.mustBeBefore(date, true);
  }

  public mustBeBeforeDate(date: Date): ValidatorFn {
    return this.mustBeBefore(date, false);
  }

  private mustBeBefore(date: Date, allowEqual = false): ValidatorFn {
    return (control: AbstractControl) => {
      if (!this.dateService.dateIsValid(date) || !this.dateService.dateIsValid(control.value)) {
        return null;
      }

      const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

      const thisValue = control.value as Date;

      if (allowEqual && isSameDay(midnight, thisValue)) {
        return null;
      } else if (isBefore(thisValue, midnight)) {
        return null;
      } else {
        return {
          max: {
            max: midnight
          }
        };
      }
    };
  }

  private mustBeAfter(date: Date, allowEqual = false): ValidatorFn {
    return (control: AbstractControl) => {
      if (!this.dateService.dateIsValid(date) || !this.dateService.dateIsValid(control.value)) {
        return null;
      }

      const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      const thisValue = control.value as Date;

      if (allowEqual && isSameDay(midnight, thisValue)) {
        return null;
      } else if (isAfter(thisValue, midnight)) {
        return null;
      } else {
        return {
          min: {
            min: midnight
          }
        };
      }
    };
  }

  public allowedDaysOfWeek(values: number[]): ValidatorFn {
    return (control: AbstractControl) => {
      if (!this.dateService.dateIsValid(control.value)) {
        return null;
      }

      let date = control.value as Date;
      let dayOfWeek = date.getDay();

      if (values.indexOf(dayOfWeek) >= 0) {
        return null;
      } else {
        return {
          dayOfWeek: {
          }
        }
      }
    };
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/validators.service.ts